import React from "react";
import { Box, Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClassCard from "../components/ClassCard/ClassCard.js";
import JoinClassModal from "../components/Modals/JoinClassModal/JoinClassModal.js";
import CreateClassModal from "../components/Modals/CreateClassModal/CreateClassModal.js";
import DeletionModal from "../components/Modals/DeletionModal/DeletionModal.js";
import { useUser } from "../globals/UserContext";

export default function Classes({ setPage }) {
  const [teacherModalOpen, setTeacherModalOpen] = React.useState(false);
  const handleTeacherOpen = () => setTeacherModalOpen(true);
  const handleTeacherClose = () => setTeacherModalOpen(false);

  const [studentModalOpen, setStudentModalOpen] = React.useState(false);
  const handleStudentOpen = () => setStudentModalOpen(true);
  const handleStudentClose = () => setStudentModalOpen(false);

  const [confirmationModalOpen, setConfirmationModalOpen] = React.useState(false);
  const handleConfirmationOpen = () => setConfirmationModalOpen(true);
  const handleConfirmationClose = () => setConfirmationModalOpen(false);

  const [confirmationEffect, setConfirmationEffect] = React.useState(() => {});
  const [confirmationText, setConfirmationText] = React.useState(""); 

  const user = useUser();
  const classes = user.classes;

  return (
    <Box sx={{ marginTop: "70px" }}>
      <Grid container>
        {classes.map((classID) => (
          <ClassCard
            item
            key={classID?._id ? classID._id : classID}
            setPage={setPage}
            isTeacher={user.isTeacher}
            classID={classID?._id ? classID._id : classID}
            //nextAssignmentName={"assignment"}
            teacher={"teacher"}
            handleConfirmationOpen={handleConfirmationOpen}
            setConfirmationEffect={setConfirmationEffect}
            setConfirmationText={setConfirmationText}
          />
        ))}
        {user.isTeacher ? (
          <Button
            onClick={handleTeacherOpen}
            variant="contained"
            color="success"
            size="large"
            startIcon={<AddIcon />}
            sx={{
              marginTop: "100px",
              marginLeft: "10px",
              marginRight: "10px",
              maxHeight: "30px",
            }}
          >
            Create Class
          </Button>
        ) : (
          <Button
            onClick={handleStudentOpen}
            variant="contained"
            color="success"
            size="large"
            startIcon={<AddIcon />}
            sx={{
              marginTop: "100px",
              marginLeft: "10px",
              marginRight: "10px",
              maxHeight: "30px",
            }}
          >
            Join Class
          </Button>
        )}
        <JoinClassModal
          open={studentModalOpen}
          setOpen={setStudentModalOpen}
          handleClose={handleStudentClose}
        ></JoinClassModal>
        <CreateClassModal
          open={teacherModalOpen}
          setOpen={setTeacherModalOpen}
          handleClose={handleTeacherClose}
        ></CreateClassModal>
        <DeletionModal 
          open={confirmationModalOpen} 
          notification={confirmationText} 
          onSubmit={confirmationEffect} 
          handleClose={handleConfirmationClose}>
        </DeletionModal>
      </Grid>
    </Box>
  );
}
